import {Col, Collapse, CustomInput, Form, FormGroup, Input, Label, Row} from "reactstrap";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import Select from "react-select";
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import SkuMapping from "../../lib/Core/Backend/Controllers/SkuMapping";
import DataTable from "../Core/DataTable";
import CardTypesCtl from "./CardTypesCtl";
import Utils from "../../lib/Utils/Utils";
import ReactNotificationAlert from "react-notification-alert";
import Notify from "lib/Utils/Alert";
import { LoginSharp } from "@mui/icons-material";


function BrandsCtl(props)
{
	const {
		supplier, token, setSelectedBrand, selectedBrand, brandList, operation, brandsSelect, cardTypeTable,
		 disableSelect, setDisableSelect, setExtraCardInfo, setExtraBrandInfoSup,formRef,setProductName,
		 setCurrencyName,
		 setAmount,
		 setMinimumAmount,
		 setMaximumAmount,
		 setCurrencyId,
		  productName,currencyId,
		 currencyName,minimumAmount,maximumAmount,amount
	} = props
	const [brands, setBrands] = useState([]);
	const [extraBrandInfo, setExtraBrandInfo] = useState(false);

	const cardTypeCtl = useMemo(() => new CardType(token), [token]);
	const skuMappingCtl = useMemo(() => new SkuMapping(token), [token]);

	const cardTypeInput = useRef();
	const alert = useRef();

	const onBrandSelect = useCallback((val, operation) =>
	{
		if(cardTypeTable.current){
			let cardTypesIds = cardTypeTable.current.dataTable.data().toArray().map(card => card.giftCardTypeId)
			switch (operation.action)
			{
				case "select-option":
					setSelectedBrand(val);
					Utils.FillDropdown(cardTypeInput.current, [], null, null, 'loading...');
					cardTypeCtl.allByBrand(val.value, data =>
					{
						Utils.FillDropdown(cardTypeInput.current, data.filter(card => !cardTypesIds.includes(card.id)), ['amount'], (entry) => `${entry.productName} - (${entry.currency}) - SKU: ${entry.sku ?? 'Not available'}`);
					});
					break;
				case "clear":
					setSelectedBrand({})
					Utils.FillDropdown(cardTypeInput.current, [], null);
					break;
				default:
					Utils.FillDropdown(cardTypeInput.current, [], null, null, 'loading...');
					if(val.value !== undefined){
						cardTypeCtl.allByBrand(val.value, data =>
							{
								Utils.FillDropdown(cardTypeInput.current, data.filter(card => !cardTypesIds.includes(card.id)), null, (entry) => `${entry.productName} - (${entry.currency}) - SKU: ${entry.sku ?? 'Not available'}`);
							});
					}
					break;
			}
		}
		
	},[cardTypeCtl, setSelectedBrand, cardTypeTable])

	function clearAll()
	{
		brandsSelect.current.clearValue();
	}

	function removeCardType(row){
		const card = row.data()
		const suppId = card.supplierId;
		if(card.status === 'new'){
			row.remove().draw();
		} else {
			skuMappingCtl.mappingsBySupplier(suppId, data => {
				const findMappingId = data.filter(mapping => mapping.giftCardTypeId === card.giftCardTypeId);
				const mappingId = findMappingId.length > 0 ? findMappingId[0].id : 0;
				skuMappingCtl.removeByIdMapping(mappingId, (e) => {
					if(e.error || e.errorMessage){
						Notify(alert, 'danger', e.errorMessage ?? e.error);
					} else {
						row.remove().draw();
					}
				})
			})
		}
	}

	useEffect(() => {
		setExtraBrandInfoSup(extraBrandInfo)
	}, [extraBrandInfo, setExtraBrandInfoSup]);

	useEffect(() =>
	{
		setBrands(brandList.map(brand => ({value: brand.id, label: brand.name})))
	},[brandList]);

	useEffect(() => {
		if(operation === 'Edit'){
			setDisableSelect(true)
			onBrandSelect(selectedBrand, {action: null})
		} else{
			setDisableSelect(false)
		}
	}, [operation, selectedBrand, onBrandSelect, setDisableSelect]);

	

	return (
		<Form innerRef={props.formRef} onReset={clearAll}>
			<ReactNotificationAlert ref={alert} />
			<Row form>
				<Col md="6">
					<FormGroup>
						<Label for="brandId">Brand</Label>
						<Select
							value = {
								brands.filter(option => {
									if(Object.keys(selectedBrand).length > 0){
									  return option.value === selectedBrand.value
									} else {
										return false
									}
									
								})
						 	}
							ref={brandsSelect}
							isDisabled={disableSelect}
							onChange={onBrandSelect}
							name="brandId"
							inputId="brandId"
							options={brands}
							isClearable={true}/>
					</FormGroup>
				</Col>
				<Col md={6}>
					<FormGroup>
						<Label for="approvalRequired">Does this brand requires approval for each gift card</Label>
						<CustomInput id="approvalRequired" name="approvalRequired" type="switch" label="Approval required"/>
					</FormGroup>
				</Col>
			</Row>
			<h6 className="ncentiva-form-section-header custom_header_colourTwo text-light">Supplier Card Type Information</h6>
			<Row form>
				<Col md={12}>
				<div className="table-responsive">
					<DataTable ref={cardTypeTable}
						data={null}
						columns={[
							{title: "Gift Card Type", data: "productName", render: (data, type, row) => {
								if(data){
									return `${data} - sku: ${row.sku ?? 'Not Available'}`
								}
							}},
							{title: "Supplier Item", data: "supplierItem", render: (data, type, row) => {
								return `${row?.productName} - sku: ${data?.sku}`
							}}
						]}
						options={{dom: "tip"}}
						addRemoveButton={{callback: removeCardType}}/></div>
					<CardTypesCtl
						supplier={supplier}
						token={token}
						formRef={props.cardTypeForm}
						onAdd={props.addCardType}
						setExtraCardInfo={setExtraCardInfo}
						cardTypeInputRef={cardTypeInput}
						brandFromRef={formRef}

						amount={amount}
						productName={productName}
						currencyId={currencyId}
						currencyName={currencyName}
						minimumAmount={minimumAmount}
						maximumAmount={maximumAmount}
                        setProductName={setProductName}
				        setCurrencyId={setCurrencyId}
					    setCurrencyName={setCurrencyName}
					    setAmount={setAmount}
						setMinimumAmount={setMinimumAmount}
						setMaximumAmount={setMaximumAmount}
						
					/>
				</Col>
			</Row>
			<h6 className="ncentiva-form-section-header text-light custom_header_colourTwo  d-flex align-items-center py-4" onClick={() => setExtraBrandInfo(!extraBrandInfo)} style={{cursor: "pointer"}}>
				<i className={extraBrandInfo ? "fas fa-chevron-up" : "fas fa-chevron-down"}/>&nbsp;&nbsp;Override general purchase limits and/or fees and discounts for this specific brand
			</h6>
			<Collapse isOpen={extraBrandInfo}>
				<Row form>
					<Col md="3">
						<FormGroup>
							<Label for="brandLimitMinAmount">Minimum Amount</Label>
							<Input type="number" name="brandLimitMinAmount" id="brandLimitMinAmount" placeholder="Minimum purchase amount in USD"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="brandLimitMaxAmount">Maximum Amount</Label>
							<Input type="number" name="brandLimitMaxAmount" id="brandLimitMaxAmount" placeholder="Maximum purchase amount in USD"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="brandLimitMinQuantity">Minimum Quantity</Label>
							<Input type="number" name="brandLimitMinQuantity" id="brandLimitMinQuantity" placeholder="Minimum number of cards"/>
						</FormGroup>
					</Col>
					<Col md="3">
						<FormGroup>
							<Label for="brandLimitMaxQuantity">Maximum Quantity</Label>
							<Input type="number" name="brandLimitMaxQuantity" id="brandLimitMaxQuantity" placeholder="Maximum number of cards"/>
						</FormGroup>
					</Col>
				</Row>
				<Row form>
					<Col md="12">
						<FormGroup>
							<Label for="brandTimeThreshold">Time period on which this limits refresh</Label>
							<Input type="select" name="brandTimeThreshold" id="brandTimeThreshold">
								<option value="-1">Select a time period</option>
								<option value="7">1 Week (7 days)</option>
								<option value="14">2 Weeks (14 days)</option>
								<option value="28">4 Weeks (28 days)</option>
								<option value="1m">Last day of the month</option>
							</Input>
						</FormGroup>
					</Col>
				</Row>
				<Row form>
					<Col md="6">
						<FormGroup>
							<Label for="brandDiscount">Brand Discount</Label>
							<Input type="number" name="brandDiscount" id="brandDiscount" placeholder="Discount percentage for purchases"/>
						</FormGroup>
					</Col>
					<Col md="6">
						<FormGroup>
							<Label for="brandFee">Brand Fee</Label>
							<Input type="number" name="brandFee" id="brandFee" placeholder="Fee charged per purchase"/>
						</FormGroup>
					</Col>
				</Row>
			</Collapse>
		</Form>
	);
}

export default BrandsCtl;